import { render, staticRenderFns } from "./AudioPlayerMusicWave.vue?vue&type=template&id=5bffa570&scoped=true&"
import script from "./AudioPlayerMusicWave.vue?vue&type=script&lang=js&"
export * from "./AudioPlayerMusicWave.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayerMusicWave.vue?vue&type=style&index=0&id=5bffa570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bffa570",
  null
  
)

export default component.exports